<template>
  <div class="invalid-feedback" role="alert">
    <strong>{{ message }}</strong>
  </div>
</template>

<script>
export default {
  name: 'ValidationMessage',
  data () {
    return {
      message: ''
    }
  },
  methods: {
    showMessage(msg) {
      this.message = msg
    },
    dismissMessage(){
      this.message = ''
    }
  }
}
</script>
